import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"font-weight-medium ml-2 mt-2",staticStyle:{"font-size":"14px"}},[_vm._v("\n    Configurações do automatizador de Tarefas\n  ")]),_c(VTabs,{staticClass:"mt-n2",attrs:{"centered":""}},[_c(VTab,[_c(VIcon,{attrs:{"left":""}},[_vm._v("mdi-cog")]),_vm._v("\n      Automatizador\n    ")],1),_c(VTabItem,{staticClass:"ma-0"},[_c(VCard,{attrs:{"flat":""}},[_c(VCardText,{staticClass:"pa-0"},[_c('automatizador-tarefas')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }